import * as React from 'react';
import {Mutation} from 'react-apollo';

import classnames from 'classnames';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {Button} from 'shells/button/button';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

import type {
    CtCtContact as CtCtContactFragment,
    SyncCtctEntity as SyncCtctEntityMutation,
    SyncCtctEntityVariables as SyncCtctEntityMutationVariables,
} from 'nutshell-graphql-types';

import SYNC_CONSTANT_CONTACT_ENTITY from './graphql/mutations/sync-constant-contact-entity.graphql';

import styles from './sync-status.module.css';

type Props = {
    entityId: string;
    ctctContact: CtCtContactFragment;
};

class UpdateNowMutation extends Mutation<SyncCtctEntityMutation, SyncCtctEntityMutationVariables> {}

export function SyncStatus({entityId, ctctContact}: Props) {
    const [errorMsg, setErrorMsg] = React.useState<string | null | undefined>(null);

    if (errorMsg) {
        return (
            <FlashBanner
                hasBorder={true}
                type='error'
                duration={8000}
                onHidden={() => setErrorMsg(null)}
            >
                {errorMsg}
            </FlashBanner>
        );
    }

    return (
        <UpdateNowMutation mutation={SYNC_CONSTANT_CONTACT_ENTITY} variables={{entityId: entityId}}>
            {(updateNow, {loading}) => {
                return (
                    <div className={classnames('flex justify-sb', styles['sync-status-container'])}>
                        {ctctContact.lastActivitySyncTime ? (
                            <div className={styles.status}>
                                Last updated{' '}
                                <RelativeTimestamp datetime={ctctContact.lastActivitySyncTime} />
                            </div>
                        ) : (
                            <div className={styles.status}>
                                Constant Contact data not yet updated
                            </div>
                        )}
                        <Button
                            variant='text-primary'
                            onClick={() => {
                                updateNow()
                                    .then(() => {
                                        Timeline.refreshTimeline();
                                    })
                                    .catch((err) => {
                                        setErrorMsg(safelyGetGraphQLErrorMessage(err));
                                    });
                            }}
                        >
                            {loading ? 'Updating…' : 'Update now'}
                        </Button>
                    </div>
                );
            }}
        </UpdateNowMutation>
    );
}
